<template>
  <div class="container-fluid">
    <div class="contents">
      <h4 class="subtitle">
        <span class="badge minigame-event-type">
          <!-- {{ eventinfo.awardtype | awardtype }} / -->
          {{ event_type(eventinfo.award_fk) }}
        </span>
        <p class="minigame-title">{{ eventinfo.title }}</p>
      </h4>
      <p class="mb-4 lh-sm" v-if="eventinfo.standard_point != 0">
        <span>{{ $t("title.common.point_allocation") }} : </span>
        <span class="text-point-sp">
          {{ $t("title.common.standard_point") }}
        </span>
      </p>
      <b-form @submit="onSubmit" class="filter-group row g-2">
        <div class="col-12 col-sm-auto">
          <select class="" name="searchtype" v-model="searchData.searchtype">
            <!-- <option value="1">{{ $t("filter.common.title") }}</option> -->
            <option value="3">
              {{ $t("filter.common.winner") }}
            </option>
            <option value="2">{{ $t("title.common.location") }}</option>

            <!-- <option value="4">{{ $t("filter.common.name") }}</option> -->
          </select>
        </div>

        <div class="col-12 col-sm-auto">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              name="searchname"
              v-model="searchData.searchname"
            />
            <button
              class="btn btn-primary btn-lg icon-search"
              type="submit"
              value=""
            ></button>
          </div>
        </div>
      </b-form>

      <table class="table board toggle-xxl">
        <thead>
          <tr>
            <!-- <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.type") }}
            </th>
            <th class="col-auto">{{ $t("title.common.title") }}</th>
            -->
            <th class="col-auto text-nowrap">
              {{ $t("title.common.winner") }}
            </th>
            <th class="col-auto d-none d-md-table-cell">
              {{ $t("title.common.location") }}
            </th>
            <!-- <th class="col-auto d-none d-lg-table-cell">Simulator No.</th> -->
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.course") }}({{ $t("title.common.hole") }})
            </th>
            <th class="col-auto">
              {{ $t("title.event.prizes") }}
            </th>
            <th
              class="col-auto d-none d-xxl-table-cell"
              v-if="eventinfo.award_fk > 8"
            >
              {{ $t("title.common.distance") }}
            </th>
            <th
              class="col-auto d-none d-lg-table-cell"
              v-if="eventinfo.standard_point != 0"
            >
              {{ $t("title.common.standard_point") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.date") }}
            </th>
            <th class="th-arrow">&nbsp;</th>
          </tr>
        </thead>
        <tbody v-if="total_cnt > 0">
          <template v-for="(item, index) in items">
            <tr class="btn1" @click="toggle_tr(index)" :key="index">
              <!-- <td class="col-auto d-none d-lg-table-cell">{{ item.no }}</td>
              <td class="col-auto d-none d-lg-table-cell">
                {{ event_type(item.type) }}
              </td>
              <td class="col-auto">{{ item.title }}</td> -->
              <td class="col-auto text-start">
                <MemberInfo
                  :nickname="item.nickname"
                  :playerno="item.playerno"
                  :member_img="item.member_img"
                  :badge_img="item.badge_img"
                />
              </td>
              <td class="col-auto d-none d-md-table-cell shop-name">
                {{ item.shopname }}
              </td>
              <!-- <td class="col-auto d-none d-lg-table-cell">
                {{ item.room_num }} 번방
              </td> -->
              <td class="col-auto d-none d-xxl-table-cell">
                {{ item.coursename }}({{ item.hole }}H)
              </td>
              <td class="col-auto text-prize">
                {{ item.type < 11 ? null || item.point : "Rank Prize" }}
              </td>
              <td
                class="col-auto d-none d-xxl-table-cell"
                v-if="eventinfo.award_fk > 8"
              >
                <template v-if="item.record">{{ item.record }}m</template>
                <template v-else>-</template>
              </td>
              <td
                class="col-auto d-none d-lg-table-cell text-point-sp"
                v-if="eventinfo.standard_point != 0"
              >
                {{ item.standard_points | comma | suffix("P") }}
              </td>
              <td class="col-auto d-none d-lg-table-cell text-date">
                <!-- 서비스 시간 -->
                {{ item.timezone_date | dateformat }}
              </td>
              <td class="td-arrow end">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xxl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="6">
                <div class="toggle-content">
                  <!-- <div class="row">
                    <div class="col-4">{{ $t("title.common.number") }}</div>
                    <div class="col-8">{{ item.no }}</div>
                  </div>
                  <div class="row d-flex align-items-center">
                    <div class="col-4">{{ $t("title.common.type") }}</div>
                    <div class="col-8">{{ event_type(item.type) }}</div>
                  </div> -->
                  <div class="row d-md-none">
                    <div class="col-4">{{ $t("title.common.location") }}</div>
                    <div class="col-8 shop-name">
                      {{ item.shopname }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.course") }}</div>
                    <div class="col-8">
                      {{ item.coursename }} {{ item.subcoursename }}
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col-4">닉네임</div>
                    <div class="col-8">
                      <MemberInfo
                        :nickname="item.nickname"
                        :playerid="item.playerid"
                      />
                    </div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-4">방번호</div>
                    <div class="col-8">{{ item.room_num }}번방</div>
                  </div> -->
                  <!-- <div class="row d-flex align-items-center">
                    <div class="col-4">{{ $t("title.common.course") }}</div>
                    <div class="col-8">{{ item.coursename }}</div>
                  </div> -->
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.hole") }}</div>
                    <div class="col-8">{{ item.hole }}H</div>
                  </div>
                  <div class="row" v-if="eventinfo.award_fk > 8">
                    <div class="col-4">{{ $t("title.common.distance") }}</div>
                    <div class="col-8" v-if="item.record">
                      {{ item.record }}m
                    </div>
                    <div class="col-8" v-else>-</div>
                  </div>
                  <!--                   <div class="row">
                    <div class="col-4">{{ $t("title.event.prizes") }}</div>
                    <div class="col-8">
                      {{ item.type < 11 ? null || item.point : "Rank Prize" }}
                    </div>
                  </div> -->
                  <div
                    class="row d-lg-none"
                    v-if="eventinfo.standard_point != 0"
                  >
                    <div class="col-4">
                      {{ $t("title.common.standard_point") }}
                    </div>
                    <div class="col-8 text-point-sp">
                      {{ item.standard_points | comma | suffix("P") }}
                    </div>
                  </div>
                  <div class="row d-lg-none">
                    <div class="col-4">
                      {{ $t("title.common.date") }}
                    </div>
                    <div class="col-8 text-date">
                      <!-- 서비스 시간 -->
                      {{ item.timezone_date | dateformat }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>

      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        aria-label="Page navigation example"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <a v-if="active">{{ page }}</a>
          <a v-else>{{ page }}</a>
        </template>
      </b-pagination-nav>

      <!-- <div class="row regis-btn">
        <div class="col-lg-6">
          <button
            class="btn btn-primary btn-xl"
            type="button"
            @click="$router.push({ name: 'MiniGameList' }).catch(() => {})"
          >
            목록
          </button>
        </div>
      </div> -->
      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-primary"
          aria-label="list"
          @click="$router.push({ name: 'MiniGameList' }).catch(() => {})"
          >{{ $t("button.common.list") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import ax from "@/api/event";
import { myMixin } from "@/mixin/myMixin";
import "@/filter/common";

export default {
  name: "WinAMiniGameList",
  data() {
    return {
      searchData: {
        searchtype: this.$route.query.searchtype || 3,
        searchname: this.$route.query.searchname || "",
        type: this.$route.query.type || 0,
        pageno: this.$route.query.pageno || 1,
        eventno: this.$route.params.eventno || 0,
      },
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 20,
      items: [],
      eventinfo: {},
      view_hide: null,
    };
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      // this.$router
      //   .push({
      //     query: {
      //       type: this.searchData.type,
      //       searchname: this.searchData.searchname,
      //       searchtype: this.searchData.searchtype,
      //     },
      //   })
      //   .catch(() => {});
    },
    get_ownereventwinninglist() {
      ax.get_ownereventwinninglist(this.searchData, (flag, data) => {
        console.log(flag, data);

        this.total_cnt = data.eventwvinninglistcnt;
        this.page_total = Math.ceil(data.eventwvinninglistcnt / this.rows);
        this.items = data.eventwvinninglist;
        this.eventinfo = data.eventinfo;

        if (!flag) alert(data.message);
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  created() {
    this.get_ownereventwinninglist();
  },
  watch: {
    // "$route.query": function () {
    //   this.searchData.pageno = parseInt(this.$route.query.page) || 1;
    //   this.get_eventwinningranklist();
    // },
    searchData: {
      handler: function (val, oldVal) {
        this.$store.commit("setSearchData", {
          [this.$route.name]: val,
        });
        this.get_ownereventwinninglist();
      },
      deep: true,
    },
  },
  mixins: [myMixin],
};
</script>
